import { useTheme } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import { PaperworkAddDocumentButton } from "web_myplann/Profile/Components/Paperwork/PaperworkAddDocumentButton";
import { PaperworkDocumentList } from "web_myplann/Profile/Components/Paperwork/PaperworkDocumentList";
import { PaperworkInfoNote } from "web_myplann/Profile/Components/Paperwork/PaperworkInfoNote";
import { usePaperworkDocuments } from "web_myplann/Profile/Hooks/usePaperworkDocuments";
import { EmptyListSkeleton } from "web_myplann/Shared/Components/EmptyListSkeleton";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

const R = Resources.Paperwork;

export const PaperworkV2Page: FC = () => {
	const theme = useTheme();
	const { t } = useResource();
	const { documents, isLoading } = usePaperworkDocuments();
	const navigate = useNavigate();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.grey[50]}
			topBar={
				<NavigationHeader
					title={t(R.title)}
					bgColor={theme.palette.background.appBar}
					defaultRoute={AppRouting.MyPlann.Profile.ProfileDetail.path()}
					alwaysUseDefaultRoute
				/>
			}
		>
			{isLoading ? (
				<MyPlannLoading />
			) : (
				<>
					{documents.length > 0 ? (
						<PaperworkDocumentList documents={documents} />
					) : (
						<EmptyListSkeleton
							label={t(Resources.Profile.EmptyList.Paperwork.label)}
							description={t(Resources.Profile.EmptyList.Paperwork.description)}
							p={1.6}
						/>
					)}

					<PaperworkAddDocumentButton
						onClick={() =>
							navigate(AppRouting.MyPlann.Profile.PaperworkAdd.path())
						}
					/>

					<PaperworkInfoNote />
				</>
			)}
		</MyPlannLayout>
	);
};
